import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_BONUSABFRAGE_STAFFELN } from '../bonusabfrage.api';
import { BonusabfrageQuery } from '../types/bonusabfrage-query';
import { TieredBonus } from '../types/tiered-bonus';

@Injectable()
export class TiredBonusRepository extends ReadonlyHttpApiListRepository<
  Result<TieredBonus[]>,
  BonusabfrageQuery | undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_BONUSABFRAGE_STAFFELN);
  }

  override getLoadQueryParams(params: BonusabfrageQuery): Dictionary<unknown> {
    return {
      bonusPeriod: params.bonusPeriod,
      billingDate: params.billingDate,
    };
  }
}
